// extracted by mini-css-extract-plugin
module.exports = {"articleList":"ArticlelistProfile_articleList__XMA8S"};